// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__3enn6","content":"styles_content__1cGe1","selectAll":"styles_selectAll__MyIyC"};